import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormField } from "@/components/ui/FormField";
import { Button } from "@/components/ui/Button";
import { supabase } from "@/lib/supabase";

export function ForgotPasswordPage() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      // Email de reset BRANDÉ via l'edge function (au lieu du template Supabase nu).
      // La fonction renvoie toujours ok (anti-énumération) → on affiche un message
      // neutre sans révéler si le compte existe. `lang` = langue courante du form
      // → l'email + la page reset arrivent dans cette langue (pas celle du profil).
      const lang = (i18n.language || "fr").slice(0, 2);
      await supabase.functions.invoke("request-password-reset", { body: { email, lang } });
      setSuccess(true);
    } catch {
      // Même en cas d'erreur réseau, on affiche le message neutre de succès.
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4"
    >
      <FormField
        label={t("auth.email")}
        value={email}
        onChange={setEmail}
        type="email"
        autoComplete="email"
      />

      {success && (
        <p className="text-sm text-text-secondary">{t("auth.resetSent")}</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}

      <Button variant="auth" type="submit" disabled={loading}>
        {loading ? t("common.loading") : t("auth.sendResetLink")}
      </Button>
      <div className="text-center">
        <Link
          to="/login"
          className="text-xs text-text-muted hover:text-accent"
        >
          {t("auth.backToLogin")}
        </Link>
      </div>
    </form>
  );
}
